import type { Thunk } from 'easy-peasy';
import { thunk } from 'easy-peasy';
import type { Injections } from '../services/injections';
import type { StoreModel } from '../';
import type { InvalidatorMutationType } from '../utils/queryInvalidation';
import { invalidateQueriesWithClient, getInvalidationKeys } from '../utils/queryInvalidation';

export interface QueryInvalidationModel {
  invalidateQueries: Thunk<
    QueryInvalidationModel,
    { mutationType: InvalidatorMutationType; entityId?: string },
    Injections,
    StoreModel
  >;
}

export const queryInvalidationModel: QueryInvalidationModel = {
  invalidateQueries: thunk(async (actions, { mutationType, entityId }, { injections, getStoreState }) => {
    try {
      const sessionPartnerUrl = getStoreState().session?.user?.sessionPartnerUrl || '';
      invalidateQueriesWithClient(
        injections.queryClient,
        getInvalidationKeys(mutationType, entityId),
        sessionPartnerUrl,
      );
    } catch (error) {
      console.error('Failed to invalidate queries:', error);
    }
  }),
};
